const PostmatePkg = require("@arnotixe.dev/postmate");
const Postmate = PostmatePkg.default || PostmatePkg;
window.Postmate = Postmate;